export const checkSameArray = (arrayA, arrayB) => {
    if (arrayA.length !== arrayB.length)
        return false;
    const conArray = arrayA.concat(arrayB);
    const dupDeleteArray = Array.from(new Set(conArray));
    return dupDeleteArray.length === arrayA.length;
};
// 指定した数で区切って二次元配列にして返す
export const separateArrayBySpecifiedNumber = (array, number) => {
    const list = [];
    let elementList = [];
    array.forEach((v, i) => {
        elementList.push(v);
        if ((i + 1) % number === 0) {
            list.push(elementList);
            elementList = [];
        }
    });
    if (elementList.length > 0)
        list.push(elementList);
    return list;
};
/*
  配列を２D配列に変換する
  --example
  toMatrix([1, 2, 3, 4, 5, 6, 7], 3) -> [[1, 2, 3], [4, 5, 6], [7]]
*/
export const toMatrix = (array, cols) => {
    const matrix = [];
    const totalRows = Math.ceil(array.length / cols);
    for (let i = 0; i < totalRows; i++) {
        matrix.push(array.slice(i * cols, (i + 1) * cols));
    }
    return matrix;
};
